import {
  AlertTriangle,
  ConciergeBell,
  PhoneCall,
  ShieldAlert,
  UtensilsCrossed,
  Wrench,
} from "lucide-react";
import { HOTEL_DEPARTMENTS } from "@/utils/alerts/departmentAlerts.js";

export const DEPARTMENT_CALLS = [
  {
    key: "reception",
    label: "Call reception",
    shortLabel: "Reception",
    department: HOTEL_DEPARTMENTS.reception,
    requestType: "Other",
    title: "Reception call request",
    icon: PhoneCall,
    primary: true,
  },
  {
    key: "housekeeping",
    label: "Call housekeeping",
    shortLabel: "Housekeeping",
    department: HOTEL_DEPARTMENTS.housekeeping,
    requestType: "RoomCleaning",
    title: "Housekeeping call request",
    icon: ConciergeBell,
  },
  {
    key: "room-dining",
    label: "Call room dining",
    shortLabel: "Room dining",
    department: HOTEL_DEPARTMENTS.roomDining,
    requestType: "FoodRestaurant",
    title: "Room dining call request",
    icon: UtensilsCrossed,
  },
  {
    key: "maintenance",
    label: "Call maintenance",
    shortLabel: "Maintenance",
    department: HOTEL_DEPARTMENTS.maintenance,
    requestType: "WiFiIssue",
    title: "Maintenance call request",
    icon: Wrench,
  },
  {
    key: "security",
    label: "Call security",
    shortLabel: "Security",
    department: HOTEL_DEPARTMENTS.security,
    requestType: "UrgentStaffAssistance",
    title: "Security assistance request",
    icon: ShieldAlert,
    urgent: true,
  },
  {
    key: "emergency",
    label: "Emergency help",
    shortLabel: "Emergency",
    department: HOTEL_DEPARTMENTS.emergency,
    requestType: "UrgentStaffAssistance",
    title: "Emergency help request",
    icon: AlertTriangle,
    urgent: true,
  },
];

export const PRIMARY_DEPARTMENT_CALL =
  DEPARTMENT_CALLS.find((call) => call.primary) || DEPARTMENT_CALLS[0];

export const OTHER_DEPARTMENT_CALLS = DEPARTMENT_CALLS.filter(
  (call) => call.key !== PRIMARY_DEPARTMENT_CALL.key,
);
